import script from "./subscription-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./subscription-item.vue?vue&type=script&setup=true&lang=ts"

import "./subscription-item.vue?vue&type=style&index=0&id=7af9aeb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af9aeb0"]])

export default __exports__